import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { MarcaTrechoSentenca, TrechoSentenca } from '../../../types/sentencaArbitral.types';
import { marcasDoTrecho } from '../../../utils/formatacaoSentenca';
interface TrechosSentencaProps {
  trechos: readonly TrechoSentenca[];
}
export function TrechosSentenca(t0) {
  const $ = _c(4);
  const {
    trechos
  } = t0;
  let t1;
  if ($[0] !== trechos) {
    t1 = trechos.map(_temp);
    $[0] = trechos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(trecho, index) {
  return <TrechoRenderizado key={`${trecho.estilo}-${index}`} trecho={trecho} />;
}
function aplicarMarca(conteudo: ReactNode, marca: MarcaTrechoSentenca): ReactNode {
  if (marca === 'negrito') return <strong className="font-semibold text-neutral-800">{conteudo}</strong>;
  if (marca === 'italico') return <em>{conteudo}</em>;
  if (marca === 'sublinhado') return <u>{conteudo}</u>;
  return <s>{conteudo}</s>;
}
function TrechoRenderizado(t0) {
  const $ = _c(7);
  const {
    trecho
  } = t0;
  let t1;
  if ($[0] !== trecho) {
    t1 = marcasDoTrecho(trecho).reduce(aplicarMarca, trecho.texto);
    $[0] = trecho;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const marcado = t1;
  if (trecho.estilo === "link") {
    let t2;
    if ($[2] !== marcado || $[3] !== trecho.href) {
      t2 = <a className="text-brand-600 font-bold hover:underline" href={trecho.href} rel="noopener noreferrer" target="_blank">{marcado}</a>;
      $[2] = marcado;
      $[3] = trecho.href;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== marcado) {
    t2 = <>{marcado}</>;
    $[5] = marcado;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}